<template>
	<ul v-if="shoppingLists?.Items?.length" aria-label="Vaše nákupní seznamy">
		<li
			v-for="item in shoppingLists.Items"
			:key="item.ID"
			class="py-3 px-6 leading-5 flex items-center gap-4 typo-body-s cursor-pointer"
			:class="item.ID === selectedShoppingList
				? 'bg-background-noticeable text-body-important'
				: 'hover:bg-background-secondary'"
			tabindex="0"
			@click="selectList(item)"
			@keydown.enter.prevent="selectList(item)"
			@keydown.space.prevent="selectList(item)"
		>
			<Loading :is-loading="pendingListId === item.ID">
				<NuxtIcon
					name="bookmark"
					class="text-lg"
					:class="item.ID === selectedShoppingList ? 'text-icon-primary' : 'text-icon-tertiary'"
					:filled="item.ID !== selectedShoppingList"
				/>
			</Loading>
			{{ item.Name }}
		</li>
	</ul>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import Loading from '~/components/ui/Loading.vue';
	import {useShoppingListsStore} from '~/stores/shoppingLists';
	import type {Gsoa_ShoppingList_GetAllShoppingListsCollection as ShoppingListSummary} from '~/openapi';

	interface Emits {
		(e: 'select', listId: number): void
	}

	const emit = defineEmits<Emits>();

	const shoppingListsStore = useShoppingListsStore();
	const {shoppingLists, selectedShoppingList} = storeToRefs(shoppingListsStore);

	const pendingListId = ref<number | null>(null);

	async function selectList(list: ShoppingListSummary) {
		if (pendingListId.value !== null || list.ID === selectedShoppingList.value) {
			emit('select', list.ID);
			return;
		}

		pendingListId.value = list.ID;
		try {
			await shoppingListsStore.setSelectedShoppingList(String(list.ID), list.Name);
			emit('select', list.ID);
		} finally {
			pendingListId.value = null;
		}
	}
</script>
